<template>
  <form :class="['controls-list']">
    <ul>
      <li v-for="(option, index) in configurator" :key="index">
        <label :for="option.label" :class="[option.disabled ? 'disabled' : null]">
          <span v-html="option.label" />
          <span>
            <select :id="option.label" v-model="option.model" :disabled="option.disabled">
              <option v-if="option.colorPicker" v-for="item in option.items" :value="item" v-html="item" />
              <option e-else v-for="item in option.items" :value="item" v-html="item" />
            </select>
            <color v-if="option.colorPicker" :background="option.model" />
          </span>
        </label>
      </li>
    </ul>
  </form>
</template>
<script>
import Color from './color'

export default {
  name: 'ControlsList',
  components: {
    Color
  },
  props: {
    /**
     * Form elements
     */
    configurator: {
      type: Object,
      required: true
    }
  }
}
</script>
<style>
.controls-list label,
.controls-list label > *
{
  display: block;
}

.controls-list ul,
.controls-list li
{
  padding: 0;
  margin: 0;
  list-style: none;
}

select
{
  display: inline-block;
  width: 50%;
  border: 1px solid #aaa;
  padding: .25em;
  border-radius: .2em;
  outline: 0;
  font-size: .8em;
  font-family: inherit;
  line-height: 1em;
  color: #f2f2f2;
  background-color: transparent;
  background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23f2f2f2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E'), linear-gradient(to bottom, #282828 0%,#282828 100%);
  background-repeat: no-repeat, repeat;
  background-position: right .7em top 50%, 0 0;
  background-size: .65em auto, 100%;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
}

select:disabled
{
  opacity: .5;
}

select:hover
{
  border-color: #888;
}

select option
{
  font-weight: normal;
}

.controls-list label
{
  padding: .25em;
  font-size: .83em;
}

.controls-list label span:first-child
{
  padding: 0 0 .5em;
}

.controls-list ul
{
  display: flex;
  flex-flow: wrap;
}

.controls-list li
{
  flex-basis: calc(100% / 3);
  flex-grow: 0;
}

.controls-list .disabled
{
  opacity: .75;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// controls-list.vue?0ccef64d